export const APP_LINKS = {
  ios: 'https://apps.apple.com/us/app/minipt-al-open-access/id6758595495',
  android: '#',
};
